export class SettingsEnums {
  static OwnViewedNameTypes = {
    USERNAME: 'username',
    FULLNAME: 'fullname',
    EXTENSION: 'extension',
  };
}
